import { render, staticRenderFns } from "./CustomFieldItem.vue?vue&type=template&id=4d1eaebe&scoped=true&"
import script from "./CustomFieldItem.vue?vue&type=script&lang=js&"
export * from "./CustomFieldItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldItem.vue?vue&type=style&index=0&id=4d1eaebe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1eaebe",
  null
  
)

export default component.exports